import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  makeStyles,
  TextField,
  Typography
} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import AddRowButton from "components/common/AddRowButton";
import ColorButton from "components/common/ColorButton";
import FileType from "components/common/FileType";
import {
  StyledTableCell,
  TableRowHead,
  UploadButton,
  useStyles
} from "components/request-document/components/Commons";
import { useFormik } from "formik";
import { HealthStatus, STATUS_PROCESS } from "libs/configs/constant";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
import useModalLoading from "libs/hooks/useModalLoading";
import { getFileObjectURL, getPathFile, openFileById } from "libs/utils/file";
import { getErrorMessage, isError } from "libs/utils/form";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllDocumentsList,
  setDocDetail
} from "redux/modules/allDocumentsSlice";
import { canEditForm } from "redux/modules/authSlice";
import { getHealthInsuranceList } from "redux/modules/healthInsuranceSlice";
import { getSmartForm } from "redux/modules/visaForm";
import AllDocumentsService from "services/AllDocumentsService";
import FileService from "services/FileService";
import * as yup from "yup";

const useStylesDialog = makeStyles((theme) => ({
  warpDialog: {
    padding: "30px",
    minWidth: "600px",
    minHeight: "200px",
  },
  dtitle: {
    color: "#40B8D4",
  },
  warpFormControl: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  d2title: {
    color: "#172B4D",
    paddingBottom: 10,
  },
  formControl: {
    width: "100%",
  },
  textDialog: {
    width: "100%",
  },
  warpButtonDialogSave: {
    display: "flex",
  },

  buttonDialogSave: {
    width: "100%",
    margin: "15px 5px",
  },
}));

export default function HealthInsurance({
  formik,
  isShowAddRow = false,
  onAddRow = () => {},
}) {
  const classes = useStyles();
  const [openRequestDoc, setOpenRequestDoc] = React.useState(false);
  const [healthSelected, setHealthSelected] = React.useState(null);
  const { showLoading, hideLoading } = useModalLoading();
  const canEdit = useSelector(canEditForm);
  const dispatch = useDispatch();
  const { consults, detail: docDetail } = useSelector(
    (state) => state.allDocuments
  );
  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();
  const HealthInsuranceList = formik.values.HealthInsuranceList;
  const HealthInsuranceLastItem =
    HealthInsuranceList[HealthInsuranceList.length - 1];

  return (
    <>
      <TableBody style={{ width: "100%" }}>
        <TableRowHead>
          <StyledTableCell colSpan={!canEdit ? 5 : 4}>
            <div className={classes.cellContent}>
              <div className={classes.wrapField}>
                <Typography variant="h6" className={classes.title}>
                  Health Insurance
                </Typography>
              </div>
            </div>
          </StyledTableCell>
        </TableRowHead>

        <TableRow>
          <StyledTableCell colSpan={!canEdit ? 5 : 4}>
            <InputLabel>
              Please upload a reference file and enter expiry date of your
              Health Insurance.
            </InputLabel>
          </StyledTableCell>
        </TableRow>

        <TableRowHead>
          <StyledTableCell width={20}>
            <InputLabel>No.</InputLabel>
          </StyledTableCell>
          <StyledTableCell>
            <InputLabel>File Upload ( PDF, JPG )</InputLabel>
          </StyledTableCell>
          <StyledTableCell>
            <InputLabel>Start Date</InputLabel>
          </StyledTableCell>
          <StyledTableCell>
            <InputLabel>Expiry Date</InputLabel>
          </StyledTableCell>
          {!canEdit && (
            <>
              <StyledTableCell style={{ textAlign: "center" }}>
                <InputLabel>Actions</InputLabel>
              </StyledTableCell>
            </>
          )}
        </TableRowHead>

        {HealthInsuranceList.map((item, index) => (
          <TableRow key={index}>
            <StyledTableCell>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>{index + 1}</InputLabel>
                </div>
              </div>
            </StyledTableCell>
            <StyledTableCell>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <FileType title="Document file" file={item.file} />
                    </div>
                    <div>
                      <div className={classes.flexRow}>
                        <UploadButton
                          id={item.healthID || index}
                          title={item.FileID ? "Edit" : "BROWSE"}
                          disabled={item.disabled || !canEdit}
                          onChange={async (event) => {
                            try {
                              showLoading();

                              const response = await FileService.uploadFile({
                                file: event.target.files[0],
                                FileID: null,
                                Status: true,
                              });

                              const fileId = response.results?.fileID;
                              const path = response.results?.path;
                              const fileObj = await getFileObjectURL(
                                getPathFile(path)
                              );
                              const [filename, ext] =
                                event.target.files[0].name.split(".");

                              formik.setFieldValue(
                                `HealthInsuranceList.${index}.file`,
                                fileObj
                              );
                              // formik.setFieldValue(
                              //   `HealthInsuranceList.${index}.filename`,
                              //   filename
                              // );
                              formik.setFieldValue(
                                `HealthInsuranceList.${index}.FileID`,
                                fileId
                              );

                              hideLoading();
                            } catch (error) {
                              hideLoading();
                            }
                          }}
                        />
                        <ColorButton
                          fullWidth={false}
                          style={{
                            width: 82,
                            marginLeft: 15,
                            fontWeight: "bold",
                          }}
                          variant="contained"
                          color="secondary"
                          size="large"
                          disabled={!item.FileID}
                          onClick={async () => {
                            openFileById(item.FileID);
                          }}
                        >
                          View
                        </ColorButton>
                      </div>
                      <FormHelperText error={item.Status === "RD"}>
                        {item.Status === "RD" && item.remark
                          ? `* ${item.remark}`
                          : " "}
                      </FormHelperText>
                    </div>
                  </div>
                </div>
              </div>
            </StyledTableCell>
            <StyledTableCell>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <DatePicker
                    disabled={item.disabled || !canEdit}
                    inputVariant="outlined"
                    name={`HealthInsuranceList.${index}.startDate`}
                    className={classes.formControl}
                    disableFuture={false}
                    openTo="year"
                    format="DD-MM-YYYY"
                    label="Start date"
                    views={["year", "month", "date"]}
                    maxDate={item.expDate ? item.expDate : undefined}
                    value={item.startDate}
                    onChange={(date) => {
                      formik.setFieldValue(
                        `HealthInsuranceList.${index}.startDate`,
                        date.format("YYYY-MM-DD")
                      );
                      // formik.setFieldValue(
                      //   `HealthInsuranceList.${index}.expDate`,
                      //   ""
                      // );
                    }}
                    error={isError(
                      `HealthInsuranceList.${index}.startDate`,
                      formik
                    )}
                    helperText={getErrorMessage(
                      `HealthInsuranceList.${index}.startDate`,
                      formik
                    )}
                  />
                </div>
              </div>
            </StyledTableCell>
            <StyledTableCell>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  {/* <TextField
                  variant="outlined"
                  className={classes.textField}
                  name={`HealthInsuranceList.${index}.expDate`}
                  type="date"
                  value={item.expDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError(
                    `HealthInsuranceList.${index}.expDate`,
                    formik
                  )}
                  helperText={getErrorMessage(
                    `HealthInsuranceList.${index}.expDate`,
                    formik
                  )}
                  disabled={item.disabled || !canEdit}
                /> */}

                  <DatePicker
                    disabled={item.disabled || !canEdit}
                    inputVariant="outlined"
                    name={`HealthInsuranceList.${index}.expDate`}
                    className={classes.formControl}
                    disableFuture={false}
                    openTo="year"
                    format="DD-MM-YYYY"
                    label="Expiry date"
                    views={["year", "month", "date"]}
                    minDate={item.startDate ? item.startDate : undefined}
                    value={item.expDate}
                    onChange={(date) => {
                      formik.setFieldValue(
                        `HealthInsuranceList.${index}.expDate`,
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError(
                      `HealthInsuranceList.${index}.expDate`,
                      formik
                    )}
                    helperText={getErrorMessage(
                      `HealthInsuranceList.${index}.expDate`,
                      formik
                    )}
                  />
                </div>
              </div>
            </StyledTableCell>
            {!canEdit && (
              <>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    {docDetail?.statusProcessId ==
                      STATUS_PROCESS.ReviewingHealthInsurance &&
                      docDetail?.healthStatus === HealthStatus.Pending &&
                      item?.draftId === docDetail.draftId &&
                      item?.Status === HealthStatus.Pending && (
                        <>
                          <div className={classes.wrapField}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <div>
                                <div className={classes.flexRow}>
                                  <ColorButton
                                    fullWidth={false}
                                    style={{
                                      width: 82,
                                      marginLeft: 15,
                                      fontWeight: "bold",
                                    }}
                                    variant="contained"
                                    color="success"
                                    size="small"
                                    onClick={async () => {
                                      if (
                                        !window.confirm(
                                          "Do you want to approve health insurance?"
                                        )
                                      )
                                        return;

                                      const body = {
                                        draftId: docDetail?.draftId,
                                      };

                                      const res =
                                        await AllDocumentsService.approveHealthinsurance(
                                          body
                                        );

                                      if (res) {
                                        await dispatch(
                                          getHealthInsuranceList({
                                            personalID: docDetail?.personalId,
                                          })
                                        );
                                        await dispatch(
                                          getSmartForm({
                                            draftId: docDetail?.draftId,
                                          })
                                        );

                                        const res2 = await dispatch(
                                          getAllDocumentsList({
                                            draftId: docDetail?.draftId,
                                          })
                                        );
                                        if (
                                          res2.payload &&
                                          res2.payload.length > 0
                                        ) {
                                          const detail = res2.payload[0];
                                          dispatch(setDocDetail(detail));
                                        }
                                      }
                                    }}
                                  >
                                    Approve
                                  </ColorButton>
                                  <ColorButton
                                    fullWidth={false}
                                    style={{
                                      width: 82,
                                      marginLeft: 15,
                                      fontWeight: "bold",
                                    }}
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    onClick={async () => {
                                      // api/visaformadmin/healthinsurance/requiredoc

                                      const body = {
                                        draftId: item.draftId,
                                        healthID: item.healthID,
                                        fileID: item.FileID,
                                        remark: null,
                                      };
                                      setHealthSelected(body);
                                      setOpenRequestDoc(true);
                                    }}
                                  >
                                    Request
                                  </ColorButton>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    {docDetail?.statusProcessId ==
                      STATUS_PROCESS.ReviewingHealthInsurance &&
                      docDetail?.healthStatus === HealthStatus.Pending &&
                      item?.Status === HealthStatus.RequestDocument && (
                        <div
                          style={{
                            textAlign: "center",
                            width: "100%",
                            fontSize: "16px",
                            color: "#40b8d4",
                            fontWeight: "500",
                          }}
                        >
                          Request Document
                        </div>
                      )}

                    {docDetail?.statusProcessId ==
                      STATUS_PROCESS.ReviewingHealthInsurance &&
                      item?.Status === HealthStatus.Approved && (
                        <div
                          style={{
                            textAlign: "center",
                            width: "100%",
                            fontSize: "16px",
                            color: "#2dce98",
                            fontWeight: "500",
                          }}
                        >
                          Approved
                        </div>
                      )}
                  </div>
                </StyledTableCell>
              </>
            )}
          </TableRow>
        ))}

        {HealthInsuranceLastItem?.Status !== HealthStatus.Draft &&
          isShowAddRow && (
            <TableRow>
              <StyledTableCell colSpan={!canEdit ? 5 : 4} align="center">
                <AddRowButton onClick={onAddRow} />
              </StyledTableCell>
            </TableRow>
          )}
        <div />
      </TableBody>

      <RequestDocumentDialog
        open={openRequestDoc}
        onClose={async (body) => {
          if (body) {
            if (!window.confirm("Do you want to request additional document?"))
              return;
            showAdminLoading();

            const _body = { ...healthSelected, remark: body.remark };

            const res = await AllDocumentsService.requestDocsHealthInsurance(
              _body
            );

            if (res) {
              await dispatch(
                getHealthInsuranceList({ personalID: docDetail?.personalId })
              );

              await dispatch(
                getSmartForm({
                  draftId: docDetail?.draftId,
                })
              );

              const res2 = await dispatch(
                getAllDocumentsList({ draftId: docDetail?.draftId })
              );
              if (res2.payload && res2.payload.length > 0) {
                const detail = res2.payload[0];
                dispatch(setDocDetail(detail));
              }
            }

            hideAdminLoading();
          }

          setOpenRequestDoc(false);
        }}
      />
    </>
  );
}

function RequestDocumentDialog(props) {
  const classes = useStylesDialog();
  const { onClose, open } = props;

  const handleClose = () => {
    onClose();
  };

  const validationSchema = yup.object({});

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      remark: "",
    },
    onSubmit: async (values) => {
      onClose({ remark: values.remark });
    },
  });

  useEffect(async () => {
    if (open) {
      formik.resetForm();
    }
  }, [open]);

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      className={classes.warpDialog}
    >
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>
        Request Document
      </DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit} id="request-doc-form">
          <div>
            <Grid container>
              <Grid
                item
                xs={12}
                md={12}
                className={classes.warpFormControl}
                style={{ marginTop: 15 }}
              >
                <InputLabel className={classes.d2title}>Remark</InputLabel>
              </Grid>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <TextField
                    variant="outlined"
                    name={`remark`}
                    value={formik.values.remark}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError(`remark`, formik)}
                    helperText={getErrorMessage(`remark`, formik)}
                    className={classes.textDialog}
                    multiline
                    rows={5}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button
                  variant="outlined"
                  size="medium"
                  type="button"
                  color="primary"
                  onClick={() => handleClose()}
                  className={classes.buttonDialogSave}
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  size="medium"
                  type="submit"
                  color="primary"
                  className={classes.buttonDialogSave}
                >
                  Submit
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
}
